import { api } from './api';
import type { RunSummary } from '../state/runStore';

/**
 * Lightweight card returned by `GET /api/runs/sales-orders`. Matches
 * `JiraManager.listOpenSalesOrders` on the server.
 */
export interface SalesOrderCard {
  srKey: string;
  srSummary: string;
  studioName: string;
  status: string;
}

export interface SrDetailTexec {
  key: string;
  summary: string;
  gameName: string;
  studioSubfolder: string | null;
  gameType: string | null;
  criticalFiles: number;
}

export interface SrDetail {
  srKey: string;
  srSummary: string;
  studio: { name: string; key: string };
  gameName: string;
  jurisdictions: string[];
  status: string;
  orderKey: string | null;
  gitlabConfigured: boolean;
  texecs: SrDetailTexec[];
}

export const runsApi = {
  list: () => api.get<RunSummary[]>('/api/runs'),
  byId: (id: string) => api.get<RunSummary>(`/api/runs/${id}`),
  listSalesOrders: () => api.get<SalesOrderCard[]>('/api/runs/sales-orders'),
  loadSalesOrder: (srKey: string) =>
    api.get<SrDetail>(`/api/runs/sales-orders/${encodeURIComponent(srKey)}`),
  create: (srKey: string, texecKey: string) =>
    api.post<RunSummary>('/api/runs', { srKey, texecKey }),
  delete: (id: string) => api.delete<unknown>(`/api/runs/${id}`),
};
